import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPackageExtraMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  packageExtraInput: GraphQLTypes.CreateExtraPackageInput;
}>;


export type AddPackageExtraMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'addPackageExtra'>
);


export const AddPackageExtraDocument = /*#__PURE__*/ gql`
    mutation addPackageExtra($packageId: String!, $packageExtraInput: CreateExtraPackageInput!) {
  addPackageExtra(packageId: $packageId, packageExtraInput: $packageExtraInput)
}
    `;

/**
 * __useAddPackageExtraMutation__
 *
 * To run a mutation, you first call `useAddPackageExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageExtraMutation, { data, loading, error }] = useAddPackageExtraMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageExtraInput: // value for 'packageExtraInput'
 *   },
 * });
 */
export function useAddPackageExtraMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageExtraMutationResult, AddPackageExtraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageExtraMutationResult, AddPackageExtraMutationVariables>(AddPackageExtraDocument, options);
      }
export type AddPackageExtraMutationHookResult = ReturnType<typeof useAddPackageExtraMutation>;